import React from 'react';
import { useTranslation } from 'react-i18next';
import { RiSearchLine, RiCloseLine } from '@remixicon/react';
import { Button, Input } from '@heroui/react';

interface SearchInputProps {
  placeholder?: string;
  value: string;
  onValueChange: (value: string) => void;
  onSearch: () => void;
  onClear?: () => void;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  disabled?: boolean;
}

export function SearchInput({
  placeholder = 'Search...',
  value,
  onValueChange,
  onSearch,
  onClear,
  className = 'w-48',
  size = 'lg',
  disabled = false
}: SearchInputProps) {
  const { t } = useTranslation();
  const handleKeyPress = React.useCallback(
    (e: React.KeyboardEvent) => {
      if (e.key === 'Enter') {
        onSearch();
      }
    },
    [onSearch]
  );

  const handleClear = React.useCallback(() => {
    onValueChange('');
    onClear?.();
  }, [onValueChange, onClear]);

  return (
    <Input
      placeholder={placeholder}
      size={size}
      value={value}
      onValueChange={onValueChange}
      onKeyPress={handleKeyPress}
      disabled={disabled}
      endContent={
        <div className="flex items-center gap-1">
          {value && (
            <Button isIconOnly size="sm" variant="light" color="danger" onPress={handleClear}>
              <RiCloseLine className="size-4" />
            </Button>
          )}
          <Button isIconOnly size="sm" variant="light" color="primary" onPress={onSearch}>
            <RiSearchLine className="size-4" />
          </Button>
        </div>
      }
      className={className}
    />
  );
}
